import React from 'react'
import { CollapickForm } from '@collapick/form';
import { Grid, Box, Button, Typography } from '@material-ui/core'
import { useTranslation } from 'react-i18next';
import useDefaultAttachmentsFormSchema from '../../FormSchemas/useDefaultAttachmentsFormSchema';


const DefaultAttachmentsForm = (props) => {
    const { initialValues, title, onSave, onCancel } = props
    const { t } = useTranslation()
    const { uploadSchema } = useDefaultAttachmentsFormSchema()

    return (
        <>
            <Grid container justify="center" >
                <Box my={2} >
                    <Typography variant="h2">{title}</Typography>
                </Box>
            </Grid>
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <CollapickForm
                        formSchema={uploadSchema}
                        onFormSubmit={onSave}
                        resetFormAfterSubmit={true}
                        initialValues={initialValues}
                        renderSubmitButton={() =>
                            <Button
                                variant="contained"
                                type="submit"
                                color="primary"
                                fullWidth>
                                {t('save')}
                            </Button>}
                        showInvalidSaveButton={true}
                        invalidSubmitText={t("cancel")}
                        onInvalidSubmit={onCancel}
                    />
                </Grid>
            </Grid>
        </>
    )
}
export default DefaultAttachmentsForm